import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { objectTool } from '../objectLibrary/ObjectTool';
import { tokenTool } from './TokenTool';
import { TokenWidget } from './TokenWidget';

export const tokenToolboxItem = ToolboxItem({
    id: 'tokenTool',
    label: 'Tokens',
    icon: 'deqo://icons/d2/token',
    ui: TokenWidget,
    weight: 1045,
    tools: [
        objectTool,
        tokenTool,
    ]
});

